import { ChangeDetectionStrategy, Component, signal } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-enterprise";

import { ICustomField } from "@shared/interfaces";

export interface ICustomFieldCellRendererParams extends ICellRendererParams {
  customField: ICustomField;
}

@Component({
  standalone: false,
  selector: "app-custom-field-cell-renderer",
  template: `
    <div class="container-flex">
      {{ displayValue() || "-" }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldCellRendererComponent implements ICellRendererAngularComp {
  params = signal<ICustomFieldCellRendererParams>(null);

  displayValue = signal<string>("");

  agInit(params: ICustomFieldCellRendererParams) {
    this.params.set(params);
    this.updateDisplayValue(params);
  }

  refresh(params: ICustomFieldCellRendererParams) {
    if (params) {
      this.params.set(params);
      this.updateDisplayValue(params);

      return true;
    }

    return false;
  }

  private updateDisplayValue(params: ICustomFieldCellRendererParams) {
    // We now expect the value to already be the field value string
    this.displayValue.set(
      params.value !== undefined && params.value !== null ? String(params.value) : "",
    );
  }
}
